<template>
  <v-main
    v-if="downloads"
    class="px-0"
  >
    <div class="title mb-3 d-flex justify-space-between">
      <span>Downloadable</span>
      <!--<v-btn @click="toggleSelectAll">
        {{ allSelected ? 'Unselect All' : 'Select All' }}
      </v-btn>-->
    </div>

    <v-list
      elevation="5"
      two-line
      subheader
    >
      <v-list-item
        v-for="(item, key) in downloads"
        :key="key"
      >
        <v-list-item-avatar>
          <v-icon large>
            {{ item.file | fileExt }}
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            style="min-width: 150px; word-break: break-word; white-space: normal;"
            v-text="item.name"
          />
          <v-list-item-subtitle
            style="min-width: 150px; word-break: break-word; white-space: normal;"
          >
            {{ item.file | fileName }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <!--<v-checkbox
            v-model="item.selected"
            color="primary"
          />-->
          <v-btn
            color="primary"
            small
            :loading="processDownload.includes(item.id)"
            @click="download(item)"
          >
            Download
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <!--<div>
      <v-btn
        v-if="hasSelected"
        color="primary"
        class="float-right mt-3"
        :loading="processDownload"
        @click="download"
      >
        Download
      </v-btn>
    </div>-->
  </v-main>
</template>

<script>
import resourceApi from '@/api/coach-profile/resource';

export default {
  name: 'Downloadable',

  filters: {
    fileName(text) {
      let name = '';
      if (text) {
        const splited = text.split('/');
        name = splited[splited.length - 1];
      }
      return name;
    },

    fileExt(text) {
      let ext = '';
      let icon = 'attach_file';
      if (text) {
        const splited = text.split('/');
        const dot = splited[splited.length - 1].split('.');
        ext = dot[dot.length - 1];
      }

      if (ext === 'pdf') {
        icon = 'mdi-file-pdf';
      } else if (['doc', 'docx'].includes(ext)) {
        icon = 'insert_drive_file';
      } else if (['xls', 'xlsx'].includes(ext)) {
        icon = 'insert_chart';
      } else if (ext === 'zip') {
        icon = 'collections_bookmark';
      } else if (['jpg', 'jpeg', 'png'].includes(ext)) {
        icon = 'mdi-file-image-outline';
      }

      return icon;
    },
  },

  props: {
    showError: {
      type: Boolean,
      default: false,
    },

    section: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    processDownload: [],
    downloads: null,
  }),

  computed: {
    // allSelected() {
    //   if (!this.downloads) return false;
    //   return !this.downloads.some((el) => !el.selected);
    // },

    // hasSelected() {
    //   if (!this.downloads) return false;
    //   return this.downloads.some((el) => el.selected);
    // },

    // fileSelected() {
    //   if (!this.downloads) return false;
    //   return this.downloads.filter((item) => item.selected);
    // },
  },

  mounted() {
    this.getDownload();
  },

  methods: {
    async getDownload() {
      try {
        const response = await resourceApi.getDownloadable(this.section.id);
        if (response && response.length) {
          this.downloads = response.map((item) => ({
            ...item,
            selected: false,
          }));
        }
      } catch (err) {
        console.log(err);
        if (err.key && ['noSubscription'].includes(err.key)) {
          this.$emit('update:showError', true);
        } else {
          this.$toast.error(err.msg);
        }
      }
    },

    // toggleSelectAll() {
    //   const value = !this.allSelected;
    //   this.downloads = this.downloads.map((el) => {
    //     const element = el;
    //     element.selected = value;
    //     return element;
    //   });
    // },

    download(item) {
      // if (this.fileSelected.length === 1) {
      //   window.open(this.fileSelected[0].file, '_self');
      // } else {
      //   this.downloadFiles();
      // }
      this.processDownload.push(item.id);
      window.open(item.file, '_self');
      setTimeout(() => {
        this.processDownload = this.processDownload.filter((el) => el !== item.id);
      }, 2500);
    },

    // async downloadFiles() {
    //   // const list = [];
    //   // const test = await Promise.all(
    //   //   this.fileSelected.map(async (item) => {
    //   //     const gateway = document.createElement('A');
    //   //     gateway.href = item.file;
    //   //     gateway.download = item.name;
    //   //     gateway.target = '_self';
    //   //     document.body.appendChild(gateway);
    //   //     gateway.click();
    //   //     document.body.removeChild(gateway);
    //   //     return true;
    //   //   }),
    //   // );
    //
    //   let delay = 0;
    //   this.processDownload = true;
    //   await this.fileSelected.forEach((item, index) => {
    //     // list.push(item.id);
    //     setTimeout(() => {
    //       // const gateway = document.createElement('A');
    //       // gateway.key = `gateway_${index}`;
    //       // gateway.href = item.file;
    //       // gateway.download = item.name;
    //       // document.body.appendChild(gateway);
    //       // gateway.click();
    //       // document.body.removeChild(gateway);
    //     }, (index) * 1000);
    //     delay = (index) * 1000;
    //   });
    //   setTimeout(() => {
    //     this.processDownload = false;
    //   }, delay);
    //
    //   // const params = list.join(',');
    //   // window.location.href =
    //   // `${process.env.VUE_APP_COACH_API_HOST}/dashboard/downloadable/?file=${params}`;
    // },
  },
};
</script>
